var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77.3888064px",
    height: "86.011px",
    viewBox: "0 0 77.3888064 86.011",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 46") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 77.3888064 0 77.3888064 86.011 0 86.011"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LeadBust",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home---Yes",
    transform: "translate(-1017, -507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(1017, 507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5909,79.1289 C60.8799,79.5209 60.1459,79.8959 59.4099,80.2449 C51.3649,84.0629 42.5819,85.2959 35.0519,85.9979 C34.2169,86.0759 33.3859,85.8059 32.7559,85.2519 C32.1259,84.6979 31.7509,83.9089 31.7209,83.0709 L31.0819,65.2609 C28.8999,65.2569 26.8619,64.9829 25.0739,64.4479 C20.0039,62.9289 13.7569,58.0799 8.7709,51.7939 C5.4919,47.6589 -0.0051,39.3589 0.0019,30.2089 C-0.0031,29.8339 0.0009,29.5169 0.0149,29.2139 C0.0159,29.2099 0.0159,29.2059 0.0159,29.2019 C0.0579,28.3099 0.1859,27.3949 0.3959,26.4829 C0.4969,26.0429 0.6189,25.5959 0.7589,25.1539 C1.8529,21.6909 5.2839,14.8109 15.9639,7.6529 C16.7999,7.0919 17.6629,6.5449 18.5269,6.0279 C19.1369,5.6629 19.7589,5.3049 20.3769,4.9649 C22.4189,3.8409 24.4629,2.8749 26.4529,2.0949 C28.5729,1.2629 30.5639,0.6679 32.3709,0.3249 C37.3469,-0.6201 42.2249,0.5029 46.4799,3.5719 C51.0859,6.8929 54.4609,12.3069 55.4129,17.8369 C55.5399,17.8729 55.8479,17.9649 55.8499,17.9659 C58.9529,18.9189 63.1529,20.9919 65.5369,25.4579 C66.0629,26.4419 66.4769,27.5279 66.7679,28.6839 L66.8219,28.9069 C66.8709,29.1159 66.9159,29.3239 66.9569,29.5369 C66.9799,29.6569 67.0029,29.7929 67.0249,29.9279 L67.0489,30.0709 C67.0709,30.2039 67.0919,30.3369 67.1089,30.4739 C67.1519,30.7969 67.1839,31.1109 67.2069,31.4209 C67.2099,31.4529 67.2119,31.4839 67.2139,31.5129 C67.2299,31.7439 67.2409,32.0089 67.2469,32.2749 C67.2489,32.3769 67.2499,32.4859 67.2499,32.5959 C67.2499,32.5959 67.2499,32.9259 67.2489,33.0209 C67.2489,33.1059 67.2489,33.1739 67.2469,33.2419 C67.2449,33.3399 67.2399,33.4369 67.2349,33.5329 C67.2349,33.5329 67.2269,33.6829 67.2269,33.6929 C67.2049,34.1619 67.1719,34.6079 67.1259,35.0309 C67.0929,35.3299 67.0539,35.6319 67.0089,35.9349 C66.4629,39.6269 65.0169,43.5629 62.9139,47.1869 C64.9689,47.7529 67.0429,49.0389 68.9479,50.9789 C69.9629,52.0109 70.7179,53.2559 71.1699,54.6319 L76.0869,58.0729 C77.1969,58.8499 77.6619,60.2649 77.2279,61.5479 C74.8259,68.6559 69.2729,74.8999 61.5919,79.1289 C61.5909,79.1289 61.5909,79.1289 61.5909,79.1289",
    id: "Fill-1",
    fill: "#1B1C27",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.769,82.9613 C42.765,82.2163 50.847,80.9333 58.102,77.4903 C65.358,74.0473 71.768,68.1793 74.339,60.5713 L57.618,48.8713 L34.011,61.8383 L34.769,82.9613 Z",
    id: "Fill-4",
    fill: "#AA3342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9747,72.3524 C42.2147,71.4934 40.8797,69.8794 40.1887,68.0464 C39.3397,65.7924 39.1507,63.4724 40.2997,61.4974 C40.9497,61.4414 43.8237,60.8904 44.4727,60.8354 C43.7087,64.2914 42.6677,69.0624 43.9747,72.3524",
    id: "Fill-6",
    fill: "#1B1C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0336,50.3275 L57.3496,48.4495 L57.1676,48.3215 L30.0296,63.2285 L30.0976,65.1225 C36.1296,64.6875 42.0756,63.0225 47.4356,60.2195 C52.1946,57.7315 56.4736,54.3475 60.0336,50.3275",
    id: "Fill-8",
    fill: "#1B1C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3843,55.34 C40.9383,62.095 31.5153,63.194 25.9493,61.526 C16.8823,58.81 2.4283,42.983 3.0623,29.351 C3.6013,17.735 22.1163,5.375 32.9393,3.321 C43.7623,1.267 52.2463,11.433 52.6273,20.35 C52.6273,20.35 63.4773,21.589 64.1693,31.692 C64.6943,39.361 59.2653,50.244 51.3843,55.34",
    id: "Fill-10",
    fill: "#C63C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0619,29.351 C2.7439,36.199 7.5949,44.734 14.5109,46.999 C24.0159,50.112 32.5589,46.35 39.9789,40.271 C45.2769,35.931 49.8459,30.703 53.4379,24.872 C54.1899,23.651 54.9009,22.381 55.5359,21.07 C53.8689,20.493 52.6279,20.35 52.6279,20.35 C52.2469,11.433 43.7629,1.267 32.9399,3.321 C22.1169,5.375 3.6019,17.735 3.0619,29.351",
    id: "Fill-12",
    fill: "#B33D18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0619,29.351 C2.7439,36.199 7.5949,44.734 14.5109,46.999 C24.0159,50.112 32.5589,46.35 39.9789,40.271 C45.2769,35.931 49.8459,30.703 53.4379,24.872 C54.1899,23.651 54.9009,22.381 55.5359,21.07 C53.8689,20.493 52.6279,20.35 52.6279,20.35 C52.2469,11.433 43.7629,1.267 32.9399,3.321 C22.1169,5.375 3.6019,17.735 3.0619,29.351",
    id: "Fill-14",
    fill: "#C63C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1542,9.2975 C44.5732,4.9825 39.1422,2.1435 32.9402,3.3215 C22.7612,5.2535 5.7822,16.3005 3.3482,27.2715 C8.6552,17.6865 13.2832,16.2895 13.2832,16.2895 C13.2832,16.2895 3.3402,25.8285 8.7992,33.7775 C14.2592,41.7265 41.7232,22.6355 38.4942,11.3645 C36.8962,5.7875 29.9952,7.6055 27.8322,8.3275 C30.6852,7.3435 42.2112,3.8525 48.1542,9.2975",
    id: "Fill-16",
    fill: "#E26675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4301,21.0349 C53.8171,20.4879 53.5091,20.4169 53.5091,20.4169 C53.4731,19.5599 53.3601,18.6919 53.1791,17.8239 C49.5271,17.3579 43.2681,17.9399 40.3651,24.6359 L53.7071,26.9679 L55.4301,21.0349 Z",
    id: "Fill-18",
    fill: "#1B1C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3651,24.636 C41.4501,20.303 48.6641,19.991 52.6281,20.35 C52.6281,20.35 63.4771,21.589 64.1691,31.692 C64.2761,33.26 64.1231,34.966 63.7621,36.726 L51.1711,38.127 C51.1711,38.127 39.2801,28.969 40.3651,24.636",
    id: "Fill-20",
    fill: "#E26675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1524,51.4737 C57.1524,51.4737 51.9494,56.7827 45.5844,60.1837 C39.2204,63.5857 39.9344,68.1477 42.8014,71.7827 C46.5834,76.5777 55.3084,74.0397 62.2134,68.4717 C69.1184,62.9047 70.1064,56.5077 66.7734,53.1167 C63.4404,49.7247 59.4584,48.7687 57.1524,51.4737",
    id: "Fill-22",
    fill: "#1B1C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8,72.7985 C53.299,72.4095 57.492,70.4225 61.307,67.3475 C64.856,64.4845 66.991,61.1405 67.162,58.1725 C67.255,56.5665 66.764,55.1685 65.743,54.1285 C63.868,52.2225 61.782,51.1905 60.16,51.3715 C59.4,51.4555 58.776,51.7965 58.252,52.4115 C58.23,52.4365 58.208,52.4615 58.184,52.4855 C57.965,52.7085 52.751,57.9925 46.266,61.4585 C43.914,62.7155 42.552,64.1665 42.216,65.7735 C41.815,67.6905 42.93,69.6125 43.936,70.8875 C45.169,72.4515 47.143,73.0945 49.8,72.7985",
    id: "Fill-24",
    fill: "#932C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7959,68.449 C53.5759,69.671 51.4189,70.427 49.5589,70.633 C46.7559,70.945 45.9199,69.886 45.6459,69.538 C44.6449,68.27 44.1719,67.06 44.3479,66.219 C44.5339,65.33 45.5249,64.351 47.1379,63.463 C47.1379,63.463 47.5819,63.224 47.7249,63.145 C54.2969,59.527 59.5209,54.234 59.7399,54.01 C59.7919,53.957 59.8459,53.898 59.8999,53.836 C59.9969,53.723 60.0799,53.649 60.1579,53.606 C60.1999,53.583 60.2709,53.551 60.4009,53.536 C61.1659,53.451 62.6339,54.074 64.1899,55.656 C64.7759,56.253 65.0449,57.058 64.9879,58.048 C64.8539,60.368 62.9659,63.21 59.9389,65.652 C58.5999,66.732 57.2059,67.673 55.7969,68.449 C55.7959,68.449 55.7959,68.449 55.7959,68.449",
    id: "Fill-26",
    fill: "#C63C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7423,27.0348 C42.6353,33.0138 46.0133,36.4318 46.0133,36.4318 L47.9313,33.9118 L40.7423,27.0348 Z",
    id: "Fill-28",
    fill: "#1B1C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3651,24.636 C41.4501,20.303 48.6641,19.991 52.6281,20.35 C52.6281,20.35 63.4771,21.589 64.1691,31.692 C64.2761,33.26 64.1231,34.966 63.7621,36.726 L51.1711,38.127 C51.1711,38.127 39.2801,28.969 40.3651,24.636",
    id: "Fill-30",
    fill: "#C63C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3375,39.5385 C38.6795,43.4135 33.1775,46.2685 27.3265,47.8455 C33.3145,47.4245 39.2095,45.7205 44.4975,42.8815 C45.6075,42.2855 46.7035,41.6345 47.9125,41.2825 C49.1215,40.9305 50.4885,40.9075 51.5805,41.5355 C52.9805,42.3395 53.6475,44.0755 53.5585,45.6865 C53.4695,47.2985 52.7455,48.8065 51.9135,50.1895 C49.0795,54.8955 44.7235,58.5935 39.7225,60.8535 C43.3385,59.7705 47.2815,57.9925 51.3845,55.3395 C59.2645,50.2445 64.6945,39.3615 64.1695,31.6915 C64.0985,30.6555 63.9155,29.7165 63.6535,28.8585 C63.1585,30.5415 62.1185,32.0655 60.7005,33.1005 C58.5825,34.6465 55.8035,35.0615 53.1975,34.7635 C47.9495,34.1615 42.3855,29.9105 40.1475,25.1255 C40.2735,28.7755 46.2765,33.8965 46.2765,33.8965 C46.3255,35.6665 44.6995,38.4055 43.3375,39.5385",
    id: "Fill-32",
    fill: "#932C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0124,35.4891 L48.0124,35.4891 C47.4624,35.0021 46.8744,34.4651 46.2764,33.8961 C43.5714,37.8461 34.8284,44.1331 29.2534,46.2551 C23.3544,48.5021 17.1324,47.6741 17.1324,47.6741 C27.7734,51.1641 41.3424,43.4001 48.0124,35.4891",
    id: "Fill-34",
    fill: "#1B1C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5158,59.0672 C26.8308,59.0622 23.1638,57.6872 20.3838,55.2682",
    id: "Stroke-36",
    stroke: "#FFFFFF",
    strokeWidth: 4.392,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.6726,
    y1: 53.699,
    x2: 18.6726,
    y2: 53.699,
    id: "Stroke-38",
    stroke: "#FFFFFF",
    strokeWidth: 4.392,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6242,23.4999 C46.4012,22.8509 48.3122,22.5699 50.1992,22.7189",
    id: "Stroke-40",
    stroke: "#FFFFFF",
    strokeWidth: 4.392,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3224,23.1171 C53.4164,23.1431 53.2284,23.0911 53.3224,23.1171",
    id: "Stroke-42",
    stroke: "#FFFFFF",
    strokeWidth: 4.392,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    fill: "#B23A18",
    points: "36.3768 79.2147 35.7458 66.0107 37.8258 65.5207 42.8588 76.0607"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.95657b88e6bd57acf88e09e9097fc8d8.svg";
export { ForwardRef as ReactComponent };